import React from "react";
import Axios from 'axios'

export class AGeradorDeLotes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            intervalo: '',
            lotes: [],
            clientes: [],
            quantidade: 0
        };

        this.getLotes()
        this.getClientes()
    }

    async getClientes() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("usuarios/listar-todos-clientes");
            this.setState({ clientes: response.data })
            console.log(response.data)
        } catch (err) {
            console.log(err);
        }
    }



    gerarPedidosRandom() {
        async function criarPedido(pedido, transacao) {
            try {
                var axiosInstance = new Axios.create({
                    baseURL: window.localStorage.getItem("apiUrl")
                });
                const response = await axiosInstance.post("pedidos/criar-pedido-teste-master", { ...pedido, transacaoId: transacao._id });
                console.log(response)
            } catch (err) {
                console.log(err);
            }
        }

        async function criarTransacao(pedido) {
            try {
                var axiosInstance = new Axios.create({
                    baseURL: window.localStorage.getItem('apiUrl')
                })
                const response = await axiosInstance.post(
                    'transacoes/criar-transacao',
                    {
                        data: new Date(),
                        documento: 'Documento Avulso',
                        valor: 7.00,
                        emissorId: pedido.clienteId._id,
                        receptorId: pedido.cambistaId,
                        tipo: 'Venda',
                        observacao: 'VENDA CAMBISTA',
                        status: true,
                        natureza: 'ENTRADA',
                        isEfetivada: false,
                        taxaComissao: 1.5
                    }
                )
                if (response.data) {
                    criarPedido(pedido, response.data)
                }
            } catch (err) {
                console.log(err)
            }

        }

        var listaClientes = this.state.clientes;
        var lotes = this.state.lotes;
        var qtd = this.state.quantidade;
        var i = 0;
        var interval = setInterval(function () {
            if (i > qtd - 1) {
                clearInterval(interval)
            }
            var clienteId = listaClientes[Math.floor(Math.random() * listaClientes.length)];
            if (clienteId.tutorId) {

                var novoPedido = {
                    cartelas: [lotes[Math.floor(Math.random() * lotes.length)].cartelas[Math.floor(Math.random() * 225)]],
                    clienteId: clienteId,
                    cambistaId: clienteId.tutorId._id,
                    gerenteId: clienteId.tutorId.tutorId,
                    status: true,
                    recebido: true,
                    validado: false,
                    codigo: `avulse${Math.floor(Math.random() * 99999999)}-${Math.floor(Math.random() * 99999999)}`
                }
                console.log(clienteId.tutorId.tutorId)
                criarTransacao(novoPedido)

            }
            i++;
        }, 10)
    }





    verificarDuplicidade() {
        var x = 0;
        var lotes = this.state.lotes;
        async function verificarSerial(cartela) {
            try {
                var axiosInstance = new Axios.create({
                    baseURL: window.localStorage.getItem("apiUrl")
                });
                const response = await axiosInstance.post("lotesDB/verificar-serial", { serial: cartela.serial });
                if (response.data.length > 1) {
                    console.log(cartela.serial)
                }
            } catch (err) {
                console.log(err);
            }
        }

        var intervalo1 = setInterval(function () {
            if (x > lotes.length - 1) {
                clearInterval(intervalo1)
            }

            for (var i = 0; i < lotes[x].cartelas.length; i++) {
                verificarSerial(lotes[x].cartelas[i]);
            }
            console.log('Lote : ' + x)
            x++;
        }, 10000);
    }


    async getLotes() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("lotesDB/todosOsLotes");
            this.setState({ lotes: response.data })

        } catch (err) {
            console.log(err);
        }
    }

    async deleteLotes() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.delete("lotesDB/delete-todos");
            this.setState({ lotes: response.data })

        } catch (err) {
            console.log(err);
        }
    }

    montarLote(lote, cartelaIndex, alternate) {
        let cartela = {
            numeros: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            serial: '',
            codigo: '00000',
            data: '00-00-0000',
            valor: '7.00'
        }

        var a1;
        var a2;
        var a3;
        var a4;
        var a5;
        var a6;
        var a7;
        var a8;
        var a9;
        var a10;
        var a11;
        var a12;
        var a13;
        var a14;
        var a15;

        if (alternate) {
            a1 = Math.floor(Math.random() * 3) + 1;
            a2 = Math.floor(Math.random() * 5) + a1 + 1;
            a3 = Math.floor(Math.random() * 7) + a2 + 1;
            a4 = Math.floor(Math.random() * 3) + a3 + 1;
            a5 = Math.floor(Math.random() * 5) + a4 + 1;
            a6 = Math.floor(Math.random() * 7) + a5 + 1;
            a7 = Math.floor(Math.random() * 3) + a6 + 1;
            a8 = Math.floor(Math.random() * 5) + a7 + 1;
            a9 = Math.floor(Math.random() * 7) + a8 + 1;
            a10 = Math.floor(Math.random() * 3) + a9 + 1;
            a11 = Math.floor(Math.random() * 5) + a10 + 1;
            a12 = Math.floor(Math.random() * 7) + a11 + 1;
            a13 = Math.floor(Math.random() * 3) + a12 + 1;
            a14 = Math.floor(Math.random() * 5) + a13 + 1;
            a15 = Math.floor(Math.random() * (74 - a14 + 1)) + a14 + 1;
        }
        else {
            a1 = Math.floor(Math.random() * 5) + 1;
            a2 = Math.floor(Math.random() * 5) + 6;
            a3 = Math.floor(Math.random() * 5) + 11;
            a4 = Math.floor(Math.random() * 5) + 16;
            a5 = Math.floor(Math.random() * 5) + 21;
            a6 = Math.floor(Math.random() * 5) + 26;
            a7 = Math.floor(Math.random() * 5) + 31;
            a8 = Math.floor(Math.random() * 5) + 36;
            a9 = Math.floor(Math.random() * 5) + 41;
            a10 = Math.floor(Math.random() * 5) + 46;
            a11 = Math.floor(Math.random() * 5) + 51;
            a12 = Math.floor(Math.random() * 5) + 56;
            a13 = Math.floor(Math.random() * 5) + 61;
            a14 = Math.floor(Math.random() * 5) + 66;
            a15 = Math.floor(Math.random() * 5) + 71;
        }
        cartela.numeros = [a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15];

        cartela.serial = cartela.numeros.join();
        var indexString = '0000' + ((lote.codigo * 250) + cartelaIndex + 1);
        indexString = indexString.substring(indexString.length - 6, indexString.length);
        cartela.codigo = indexString.substring(0, 5) + "-" + indexString[5];
        if (indexString[5] != '0') {
            lote.cartelas.push(cartela);
        }
    }

    gerarLotes() {
        this.deleteLotes()
        var alternate = true;
        for (var codigo = 0; codigo < 500; codigo++) {
            var lote = {
                cartelas: [],
                codigo: codigo + 1
            }
            for (var cartelaIndex = 0; cartelaIndex < 250; cartelaIndex++) {
                alternate = !alternate;
                setInterval(this.montarLote(lote, cartelaIndex, alternate), 10);
            }
            this.createLoteDB(this.loteValidade(lote))
        }
    }

    loteValidade(lote) {
        var cartelas = []
        var isInclude = false;
        lote.cartelas.map(cartelaX => {

            isInclude = lote.cartelas.some(cartelaY => cartelaX.codigo != cartelaY.codigo && cartelaX.serial == cartelaY.serial)
            if (!isInclude) {
                cartelas.push(cartelaX)
            }
        })
        lote.cartelas = cartelas;
        return lote;
    }

    handlerQtd(e) {
        this.setState({ quantidade: e.target.value })
    }

    async createLoteDB(lote) {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("lotesDB/inserir-lote", { ...lote });
            console.log(response.data)
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <button onClick={this.gerarLotes.bind(this)}>Gerar</button>
                    <button onClick={this.verificarDuplicidade.bind(this)}>Verificar Duplicidade</button>
                </div>
                <div className="row">
                    <input type='number' onChange={this.handlerQtd.bind(this)}></input>
                    <button onClick={this.gerarPedidosRandom.bind(this)}>Gerar Pedidos</button>
                </div>
            </div>
        );
    }
}






export default AGeradorDeLotes;
